import React from "react";

const Schedule = () => {
  return (
    <div className="w-full max-w-4xl mx-auto px-4 py-6">
      <h2 className="text-2xl md:text-3xl mb-4">Program schedule will be updated.</h2>
      
      <h3 className="text-xl md:text-2xl mt-6 mb-2">
        Program sessions are given below:
      </h3>

      {/* Core Sessions */}
      <h4 className="text-lg font-semibold mb-2">Core sessions:</h4>
      <p className="text-md md:text-lg mb-4">
        Basic Immunology, Cancer Immunology, Viral Immunology, Immunology of other 
        infectious diseases, Immunology of autoimmune diseases, Transplantation 
        Immunology, Challenges to immune response: AMR, Immune suppression, etc.
      </p>

      {/* Theme-specific Sessions */}
      <h4 className="text-lg font-semibold mb-2">Theme-specific sessions:</h4>
      <p className="text-md md:text-lg">
        Cellular Immunotherapies; Preventive and therapeutic Vaccines; Checkpoint Inhibitors 
        as immunomodulators; Cytokines, agonist etc. as immunomodulators; Oncolytic Virus 
        Therapy; Targeted Antibodies as precision immunotherapy, Immunodiagnostics, Immune 
        engineering.
      </p>
    </div>
  );
};

export default Schedule;
